module.exports = __webpack_public_path__ + "img/Contract.47b5f218.svg";